import axios from '@/core/axios'
import { Category } from '@ortros/stoux-lib'
import { HttpResponse } from 'nexus-res'
import { CategoryNode } from 'stoux-shared-types/services/category'
import { ListCategoriesInput } from '../schemas'

type ListCategoryResponse = {
    categories: Category[]
    count: number
    limit: number
    offset: number
}

export class CategoryRepository {
    public async getFeaturedCategories(): Promise<ListCategoryResponse> {
        const { data } = await axios.get<HttpResponse<ListCategoryResponse>>(
            '/categories/featured',
        )
        return data.metadata!
    }

    public async listCategories({
        limit,
        offset,
        all,
        withTemplatesCount,
    }: ListCategoriesInput) {
        const url = new URLSearchParams()

        if (limit) {
            url.append('limit', limit.toString())
        }

        if (offset) {
            url.append('offset', offset.toString())
        }

        if (all) {
            url.append('all', all.toString())
        }

        if (withTemplatesCount) {
            url.append('withTemplatesCount', withTemplatesCount.toString())
        }

        const { data } = await axios.get<
            HttpResponse<CategoryNode | Category[]>
        >(`/categories?${url.toString()}`)
        return data.metadata
    }

    public async getParentCategoriesWithDepth(): Promise<Category[]> {
        const { data } =
            await axios.get<HttpResponse<Category[]>>(`/categories/tree`)
        return data.metadata!
    }
}
